if (!customElements.get('build-a-stack')) {
  customElements.define(
    'build-a-stack',
    class BuildAStack extends HTMLElement {
      constructor() {
        super();

        this.disabled = false;
        this.quantity = 0;
        this.productId = this.dataset.productId;
        this.variantId = this.dataset.variantId;
        this.percentageOff = parseInt(this.dataset.percentageOff, 10);
        this.minQuantity = parseInt(this.dataset.minQuantity, 10);
        this.boxId = null;
        this.products = this.querySelectorAll('[data-stack-product]');
        this.sellingPlanSelect = this.querySelector('[data-stack-selling-plan]');
        this.sellingPlan = this.sellingPlanSelect.value;
        this.submit = this.querySelector('[data-stack-submit]');
        this.buy = this.querySelector('[data-stack-buy]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.progress = this.querySelector('[data-stack-progress]');
        this.progressBar = this.querySelector('[data-stack-progress-bar]');
        this.scroll = this.querySelector('[data-stack-scroll]');
        this.price = this.querySelector('[data-stack-price]');
        this.infoPrice = this.querySelector('[data-stack-info-price]');
        this.infoFullPrice = this.querySelector('[data-stack-info-price-full]');
        this.hero = this.querySelector('[data-stack-hero]');
        this.inventory = this.querySelector('[data-stack-inventory]');
        this.gifts = this.querySelectorAll('[data-stack-gift]');
        this.giftContainer = this.querySelector('[data-stack-gift-container]');
        this.info = this.querySelector('[data-stack-info]');
        this.modal = this.querySelector('[data-stack-modal]');
        this.modalContent = this.querySelector('[data-stack-modal-content]');
        this.modalClose = this.querySelector('[data-stack-modal-close]');
        this.toast = this.querySelector('[data-stack-toast]');
        this.selectedProducts = [];

        if (this.productId) {
          this.init();

          this.sellingPlanSelect.addEventListener('change', (e) => {
            this.updateSellingPlan(e);
          });

          this.submit.addEventListener('click', (e) => {
            this.handleSubmit(e);
          });

          this.info.addEventListener('click', (e) => {
            this.modal.classList.toggle('visually-hidden', false);
          });

          this.modal.addEventListener('click', (e) => {
            this.modal.classList.toggle('visually-hidden', true);
          });

          this.modalClose.addEventListener('click', (e) => {
            this.modal.classList.toggle('visually-hidden', true);
          });

          this.scroll.addEventListener('click', (e) => {
            e.preventDefault();

            if (this.buy) {
              this.buy.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }
          });

          this.products.forEach((product) => {
            const increaseButton = product.querySelector('[data-stack-increase]');
            const decreaseButton = product.querySelector('[data-stack-decrease]');
            const addButton = product.querySelector('[data-stack-add]');

            product.addEventListener('click', () => {
              this.handleProductClick(product);
            });

            addButton.addEventListener('click', () => {
              this.handleQuantityIncrease(product);
            });

            increaseButton.addEventListener('click', () => {
              this.handleQuantityIncrease(product);
            });

            decreaseButton.addEventListener('click', () => {
              this.handleQuantityDecrease(product);
            });
          });
        }
      }

      init() {
        fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            productPlatformId: this.productId,
          }),
        })
          .then((response) => response.json())
          .then((response) => {
            this.boxId = response.DynamicBox.boxId;
          });
      }

      updateSellingPlan(e) {
        this.sellingPlan = e.target.value;
      }

      handleProductClick(product) {
        const id = product.dataset.stackProduct;
        const image = product.querySelector('img');

        const info = product.querySelector('[data-stack-product-info]').innerHTML;
        this.handleModalUpdate(info);

        this.products.forEach((p) => {
          p.classList.toggle('selected', p.dataset.stackProduct === id);

          if (p.dataset.stackProduct === id) {
            this.hero.src = image.src;
            this.hero.srcset = image.srcset;
          }
        });
      }

      handleQuantityIncrease(product) {
        const quantity = parseInt(product.dataset.quantity, 10);
        const quantityInput = product.querySelector('[data-stack-quantity');
        quantityInput.textContent = quantity + 1;
        product.setAttribute('data-quantity', quantity + 1);
        this.handleProductSelection(product, quantity + 1);
        this.handleQuantityChange(1);

        this.toast.style.opacity = 1;
        setTimeout(() => {
          this.toast.style.opacity = 0;
        }, 2000);
      }

      handleQuantityDecrease(product) {
        const quantity = parseInt(product.dataset.quantity, 10);
        const quantityInput = product.querySelector('[data-stack-quantity');
        if (quantity > 0) {
          quantityInput.textContent = quantity - 1;
          product.setAttribute('data-quantity', quantity - 1);
          this.handleProductSelection(product, quantity - 1);
          this.handleQuantityChange(-1);
        }
      }

      handleQuantityChange(quantity) {
        this.quantity = this.quantity + quantity;
        this.submit.disabled = this.quantity < this.minQuantity;
        this.submit.setAttribute('aria-disabled', this.quantity < this.minQuantity);
        this.handleProgress(this.quantity);
      }

      handleProductSelection(product, quantity) {
        const id = product.dataset.stackProduct;
        const price = product.dataset.stackProductPrice;
        const title = product.dataset.stackProductTitle;
        const freeGifts = product.dataset.stackGiftTitle;
        const existing = this.selectedProducts.find((item) => item.id === id);

        if (existing) {
          existing.quantity = quantity;
          const index = this.selectedProducts.indexOf(existing);

          this.selectedProducts[index] = existing;
          if (existing.quantity === 0) {
            this.selectedProducts.splice(index, 1);
          }
        } else {
          this.selectedProducts.push({
            id,
            price,
            quantity,
            title,
            freeGifts,
          });
        }

        this.handleUpdateFreeGifts(this.selectedProducts);
        this.handleInfoUpdate(this.selectedProducts);
      }

      handleModalUpdate(info) {
        this.info.classList.toggle('visually-hidden', false);
        this.modalContent.innerHTML = info;
      }

      handleInfoUpdate(products) {
        const price = products.reduce((acc, product) => {
          return acc + product.price * product.quantity;
        }, 0);

        const discountedTo = 100 - this.percentageOff;
        const fullPrice =
          (price / discountedTo) % 1 === 0 ? (price / discountedTo).toFixed(0) : (price / discountedTo).toFixed(2);
        this.price.classList.toggle('visually-hidden', price === 0);

        this.infoFullPrice.innerHTML = fullPrice;
        this.infoPrice.innerHTML = (price / 100) % 1 === 0 ? (price / 100).toFixed(0) : (price / 100).toFixed(2);

        this.inventory.innerHTML = products
          .map((product) => {
            const quantity = parseInt(product.quantity, 10);
            const title = product.title;
            return `<li>${title} x ${quantity}</li>`;
          })
          .join('');
      }

      handleUpdateFreeGifts(products) {
        const gifts = products
          .map((product) => product.freeGifts)
          .flatMap((item) => item.split(','))
          .join(',');

        const hasGifts = gifts.length > 0;
        this.giftContainer.classList.toggle('visually-hidden', !hasGifts);

        this.gifts.forEach((gift) => {
          const isVisible = gifts.includes(gift.dataset.stackGift);
          gift.classList.toggle('visually-hidden', !isVisible);
        });
      }

      handleProgress() {
        if (this.quantity > this.minQuantity) return;
        else if (this.quantity === this.minQuantity) {
          this.progressBar.style.width = '100%';
          this.progress.parentElement.classList.add('enabled');
        } else {
          this.progressBar.style.width = `${(this.quantity / this.minQuantity) * 100}%`;
          this.progress.innerHTML = `Add ${this.minQuantity - this.quantity} more product(s) to checkout`;
          this.progress.parentElement.classList.remove('enabled');
        }
      }

      handleSubmit(e) {
        e.preventDefault();

        if (!this.boxId || this.disabled) return;
        this.disabled = true;
        const sections = this.cart.getSectionsToRender().map((section) => section.id);
        const boxDate = new Date().toISOString();
        const items = this.selectedProducts.map((product) => ({
          id: product.id,
          quantity: product.quantity,
          selling_plan: this.sellingPlan,
          properties: {
            _dynamicBoxIndex: 0,
            _dynamicBoxId: this.boxId,
            _dynamicBoxDate: boxDate,
          },
        }));

        const config = {
          ...fetchConfig(),
          body: JSON.stringify({
            items,
            sections,
            sections_url: window.location.pathname,
          }),
        };

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.error = true;
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'build-a-stack',
                productVariantId: this.variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'build-a-stack',
                productVariantId: this.variantId,
                cartData: response,
              });
            }
            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.disabled = false;
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.handleReset();
          });
      }

      handleReset() {
        this.selectedProducts = [];
        this.submit.disabled = true;
        this.quantity = 0;
        this.handleProgress();
        this.handleInfoUpdate(this.selectedProducts);
        this.handleUpdateFreeGifts(this.selectedProducts);
        this.products.forEach((product) => {
          product.setAttribute('data-quantity', 0);
        });
      }
    }
  );
}
